module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "season-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Duel")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/register-liga'
      }
    }
  }, [_vm._v("List Register Liga")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(!_vm.$route.query.id ? 'Buat' : 'Update') + " Register Liga")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v(_vm._s(!_vm.$route.query.id ? 'Buat' : 'Update') + " Register Liga")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(!_vm.$route.query.id ? 'Buat' : 'Update') + " Register Liga")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(this.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errors), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Nama Register Liga")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.name),
      expression: "data.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Deskripsi")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('app-editor', {
    attrs: {
      "rows": 8,
      "value": _vm.data.description,
      "context": _vm.data.description
    },
    on: {
      "content-updated": function($event) {
        _vm.data.description = $event
      }
    }
  })], 1)])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [(!_vm.$route.query.id) ? _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveData()
      }
    }
  }, [_vm._v("Simpan")]) : _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.editData()
      }
    }
  }, [_vm._v("Update")])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1747cf2c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/duel/register_liga/RegisterLigaForm.vue
// module id = 1288
// module chunks = 0